import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild, effect } from "@angular/core";
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, MinLengthValidator, Validators } from "@angular/forms";
import { PersonSearchService } from "../_services/person-search.service";
import { LocalStorageService } from "../_services/local-storage.service";
import { CandidateService } from "../_services/candidate.service";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import moment from "moment";
import { TransactionService } from "../_services/transaction.service";
import { CandidateEmailComponent } from "../candidate/candidate-email/candidate-email.component";
import { ActivatedRoute, Route, Router } from "@angular/router";
import * as __ from 'lodash';
import { WebbtreeVerifiedService } from "../_services/webbtree-verified.service";
import { CampaignService } from "../_services/campaign.service";
import { GlobalService } from "../_services/global.service";
import { MatRadioButton as MatRadioButton } from "@angular/material/radio";
import { MatExpansionPanel } from "@angular/material/expansion";
import { TimezonesService } from "../timezones.service";
import { debounce, debounceTime } from 'rxjs/operators';
import { Subject } from "rxjs";
import { SessionStorageService } from "../_services/session-storage.service";
import { AggregationService } from "../_services/aggregation.service";
import { AiSourcingService } from "../_services/ai-sourcing.service";
import { CandidateSelectionService } from "../projects/services/candidate-selection.service";
declare const clevertap;

@Component({
    selector: "app-person-search-contact-slider",
    templateUrl: "./person-search-contact-slider.component.html",
    styleUrls: ["./person-search-contact-slider.component.scss"],
    standalone: false
})
export class PersonSearchContactSliderComponent implements OnInit {

  /**
   * Required details of candidate
   * Sent from person search listing, email campaign candidate slider, and talentpool candidate slider
   * Following keys should be present in candidateDetails object: idinindex (elasticid), candidatenumber, iswebbtreeverified, usedWebbtreeIntroduction, revealContactAttempted
  */
  @Input() candidateDetails;

  /**target data of email campaign, used to send in add-contact-detail component */
  @Input() emailCampData: any;

  /**Event to notify person-search-listing, candidate-list, and email campaign-target-listing */
  @Output() handleOutputEvent = new EventEmitter<{ action: string, data: any }>();

  /**If reached here from add to manually button of email-campaign */
  @Input() addToContactOpen: boolean = false;

  timezones: string[];

  /**Elastic id of user */
  elasticid: string = '';

  /**Varaible used to know the location current location of contact slider */
  enrichedfrom: string = 'person-search-listing';

  /**Total available credits user have */
  totalCreditsAvailable: number = null;

  /**All contact information of user */
  allExistingContactDetails: any;

  /**Phone number of candidate */
  phones: any[] = [];
  /**Personal email's of candidate */
  personal_email: any[] = [];
  /**Professional email of candidate */
  work_email: any[] = [];

  /**Webtree Introduction date and time slots */
  dateTimeMasterForm = this.fb.group({
    dateTimeSlot_0: this.fb.group({
      date: new UntypedFormControl(moment().add(2, 'days').format('YYYY-MM-DD')),
      fromTime: new UntypedFormControl('14:00'),
      toTime: new UntypedFormControl('16:00'),
      timezone: new UntypedFormControl(TimezonesService.timeZoneAbbrevation([Intl.DateTimeFormat().resolvedOptions().timeZone]))
    })
  })

  minDateIntro: string = moment().add(2, 'days').format('YYYY-MM-DD')
  maxDateIntro: string = moment().add(30, 'days').format('YYYY-MM-DD')

  /**An array of objects of date, fromtime, totime, and timezone, Used to send in request body */
  dateTimeSlotsArray: any[] = [];

  /** Form used for text message written by user in Webbtree Introduction */
  webbtreeIntroductionMessageForm: UntypedFormControl = new UntypedFormControl(null, Validators.compose([Validators.required, Validators.minLength(10), Validators.maxLength(1000)]));

  /**Object used to know about preview of contact details. */
  isPreviewAvailable: { work_email: boolean, personal_email: boolean, phone: boolean } = { work_email: false, personal_email: false, phone: false }

  /**List of providers from which gives data on reveal */
  contactProviderData: string[] = [];

  /**Is any of verified, introduction or contact reveal(got contact details) has success */
  hasAnyOfRequestSuccess: boolean = false;

  /**Candidate number of candidate */
  candidateNumber: string = '';

  /**show the add to contact section */
  canShowAddToContact: boolean = false;

  /**Data regarding email, which we want to edit, Used to send in add-contact-detail component */
  editManualContactInfo: any = { type: null, contactValue: null };

  /**Access radio button for webtree verfied */
  @ViewChild('webtreeVerifiedRadioBtn') webtreeVerifiedRadioBtn: MatRadioButton;

  /**Access radio button for webtree inroduction */
  @ViewChild('webtreeIntroductionRadioBtn') webtreeIntroductionRadioBtn: MatRadioButton;

  /**Access radio button for reveal contact block */
  @ViewChild('contactRevealRadioBtn') contactRevealRadioBtn: MatRadioButton;

  /**Access contact reval mat-expansion panel */
  @ViewChild('contactRevealPanel') contactRevealPanel: MatExpansionPanel;

  /**Access webtree intoduction mat-expansion panel */
  @ViewChild('webtreeIntroExpansionPanel') webtreeIntroExpansionPanel: MatExpansionPanel;

  /**Access webtree verified mat-expansion panel */
  @ViewChild('webtreeVerifiedExpansionPanel') webtreeVerifiedExpansionPanel: MatExpansionPanel;

  /**Error message, will used to show error toast */
  errorMessage: string = ''

  /**Sucess message, will used to show success toast */
  successMessage: string = ''

  /**Used to show custom toast message on successfull reveal */
  customToast: boolean = false;

  isteamMember: boolean = false;
  @ViewChild('noCreditsCE') noCreditsCE: TemplateRef<any>;


  /**Webtree introduction api pending status */
  isIntroductionLoading: boolean = false;

  /**Webtree verified api pending status */
  isVerifiedLoading: boolean = false;

  /**Reveal Contact api pending status */
  isRevealContactLoading: boolean = false;

  /**Preview api pending status */
  isPreviewPending: boolean = false;

  /**Fetch existing contact details api pending status */
  isFetchExistingContactPending: boolean = false;

  isExtensioninstalled: any;

  /**Any of contact details present or not except added-manually contact */
  availableContactDetailNotManual: boolean = false;

  /** Value changes onClick of close icon */
  isCloseNoDataFound: boolean = false;

  CREDITS_REQUIRED = GlobalService.ENRICHMENT_CREDITS;

  /**Is current user allowed for webtree verified and webtree introduction or not */
  internalUser: boolean = false;


  isRevealContactEmailLoading: boolean = false;

  /**
   * TRMS-2797: true while a FullEnrich fallback job (kicked off in the background when
   * SignalHire alone left a gap) is still in flight for this candidate - either just triggered
   * by revealContactV2(), or detected as already in-flight on init via checkFullEnrichPendingStatus().
   */
  isFullEnrichPending: boolean = false;

  /**
   * TRMS-2797: Message shown while a FullEnrich fallback job is pending. The default promises no email -
   * it's what retry (which sends none) and a reopened pending candidate show. A single reveal that goes
   * pending overwrites it with the backend's own message (that flow does email the result).
   */
  fullEnrichPendingMessage: string = "We're still working on getting these details. We'll email you as soon as they're ready.";
  userData: any;
  /**Used to debounce onClick activity tracking api */
  deb = new Subject<any>();
  contactDetails: any;
  projectnumber: string = '';
  @Output() revealContactEventEmitter = new EventEmitter<any>();
  @Input() bulkRevealContactStatus: any;

  constructor(
    private fb: UntypedFormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private sessionStorage: SessionStorageService,
    private _localstorageservice: LocalStorageService,
    public requestContract: WebbtreeVerifiedService,
    private campaignService: CampaignService,
    private modalService: NgbModal,
    private transactionservice: TransactionService,
    private personSearchService: PersonSearchService,
    public candidateservice: CandidateService,
    private aggService: AggregationService,
    private aiSourcingService: AiSourcingService,
    private candidateSelectionService: CandidateSelectionService,
  ) {
    // Reveal contact already notifies TransactionService's own credit-consumed refresh (see
    // CreditActivityService); reacting to the shared signal here - instead of this component
    // calling /paymentflow/fetchcurrentplancredits itself - avoids firing the credits API twice
    // for the same reveal.
    effect(() => {
      const creditsData = this.transactionservice.credits();
      if (creditsData) {
        this.totalCreditsAvailable = creditsData.balancebasiccontactenrichmentcredits;
        if (creditsData.teamadmindetails) {
          this.isteamMember = true;
        }
      }
    });
  }

  ngOnInit() {
    //@ts-ignore
    console.log(this.bulkRevealContactStatus, 'bulkRevealContactStatus in contact slider')
    this.timezones = TimezonesService.timeZoneAbbrevation();
    this.elasticid = this.candidateDetails?.idinindex || this.candidateDetails?.elasticid || this.candidateDetails?.id || '';
    if(this.isAISourcingTab){
      this.projectnumber = window.location.pathname?.split('/')[4];
      if(this.candidateDetails?.existingContactDetails?.length == 0)this.getContactsForShortlist()
    }


    let userData = this._localstorageservice.getItem('userdata');
    this.userData = this._localstorageservice.getItem('userdata');
    this.totalCreditsAvailable = userData['balancebasiccontactenrichmentcredits']

    this.internalUser = this.isCurrentUserInternal();
    this.getEnrichedFromComponent();

    // this.revealContactV2();

    //In case of person-search listing
    if (this.enrichedfrom !== 'person-search-listing') {
      this.candidateDetails?.revealContactAttempted ? this.getAllContactDetailsV2() : this.segregateContactDetails(this.candidateDetails?.existingContactDetails);
    }
    else
      this.segregateContactDetails(this.candidateDetails?.existingContactDetails)

    if(!this.internalUser){
      this.hasAnyOfRequestSuccess = (this.hasAnyOfRequestSuccess || this.candidateDetails?.iswebbtreeverified || this.candidateDetails?.usedWebbtreeIntroduction);
    } else{
      this.hasAnyOfRequestSuccess = this.hasAnyOfRequestSuccess ||  this.candidateDetails?.revealContactAttempted;
    }

    //Get preivew only if user not attempted for reveal
    // (!this.candidateDetails?.revealContactAttempted) && this.getPreviewContactDetailV2();

    // TRMS-2797: check if a FullEnrich fallback job triggered by an earlier reveal click is
    // still in flight for this candidate, so a page refresh/reopen shows the "still working on
    // it" state instead of resetting to the initial Reveal Contact button.
    // Not gated on revealContactAttempted: this slider sets that flag itself as soon as ANY contact is saved, and SignalHire's
    // arrives first while FullEnrich is still running - a candidate with a partial result looked finished and its running
    // request was never looked for.
    this.checkFullEnrichPendingStatus();

    this.candidateNumber = this.candidateDetails?.candidatenumber || this.candidateNumber;
    if (this.enrichedfrom !== 'person-search-listing' && this.addToContactOpen) {
      this.canShowAddToContact = true;
    }
    else {
      this.canShowAddToContact = false;
    }

    this.deb.pipe(debounceTime(800)).subscribe((payload) => {
      this.candidateservice.trackContactdetailsClicked(payload).subscribe();
    })

    if(this.bulkRevealContactStatus == 1) {
      this.isRevealContactLoading = true;
    }


  }

  get isAISourcingTab() {
    return this.aiSourcingService.isAISourcingTab;
  }
  /**
   * Toast message
   * @param message Toast message
   * @param type type of action i.e. error, success, custom -> only used for reveal success
   */
  toastmessage(message: string, type: string) {
    if (type == 'success') {
      this.successMessage = message;
      setTimeout(() => this.successMessage = '', 5000);
    } else if (type == 'error') {
      this.errorMessage = message;
      setTimeout(() => this.errorMessage = '', 5000);
    } else if (type == 'custom') {
      this.customToast = true;
      setTimeout(() => this.customToast = false, 5000);
    }
  }

  /**
   * Function will set "enrichedfrom" key on the basis of current url.
   * It helps to identifies the location, as Person search contact slider is used on multiple places.
  */
  getEnrichedFromComponent() {
    if (this.router.url) {
      if (this.router.url.includes('talentpool')) {
        this.enrichedfrom = 'talentpool';
      }
      else if (this.router.url.includes('candidate-list')) {
        this.enrichedfrom = 'all-candidates'
      }
      else if (this.router.url.includes('email-campaign')) {
        this.enrichedfrom = 'email-campaign-target-listing'
      } else if(this.router.url.includes('searchtoolbox-v2')) {
        this.enrichedfrom = 'searchtoolbox-v2'
      }
      else if(this.router.url.includes('searchtoolbox-v2')) {
        this.enrichedfrom = 'searchtoolbox-v2'
      }
    }
  }

  /**
   * Used to close the div of no data found
   */
  closeNoDataFound(){
    this.isCloseNoDataFound = true;
  }

  nothingToRemove(){
    return (this.candidateDetails?.usedWebbtreeIntroduction && this.candidateDetails?.iswebbtreeverified && (this.candidateDetails?.revealContactAttempted || this.isCloseNoDataFound))
  }

  /**
   * Length of Form Group used to know the count of sub-forms present
   */
  formLength() {
    const innerFormGroup = this.dateTimeMasterForm.controls;
    return Object.keys(innerFormGroup);
  }

  /**
   * Used to add new form group for date and time slots
   */
  addNewDateTimeFormSlot() {
    this.validateWebtreeIntoductionForm();
    if (this.dateTimeMasterForm.status === 'VALID') {
      const uniqueId = GlobalService.generateUniqueId();
      const fromGroup = this.dateTimeMasterForm;
      fromGroup.addControl(`dateTimeSlot_${uniqueId}`, new UntypedFormGroup({
        date: new UntypedFormControl(),
        fromTime: new UntypedFormControl('14:00'),
        toTime: new UntypedFormControl('16:00'),
        timezone: new UntypedFormControl(TimezonesService.timeZoneAbbrevation([Intl.DateTimeFormat().resolvedOptions().timeZone]))
      }));
    }
  }

  /**
   * Used to remove date time slots from form group
   * @param formGroup Name of form group which we want to remove.
   */
  deleteDateTimeFormSlot(formGroup: string) {
    this.dateTimeMasterForm.removeControl(formGroup);
  }

  /**
   * Fetches the current basic-contact-enrichment credit balance fresh from the API and reports
   * whether it covers `required` credits, via `callback`. -1 means unlimited (team/plan sentinel
   * - see bulk-reveal-modal.component.ts for the same check). Always hits the API rather than
   * reading totalCreditsAvailable, since this gates whether the reveal proceeds and must reflect
   * the true current balance, not whatever was last pushed into the shared signal.
   */
  private checkHasEnoughCredits(required: number, callback: (hasEnough: boolean) => void): void {
    this.transactionservice.updateAllCreditsForCurrentUser().subscribe((creditsData: any) => {
      const available = creditsData?.balancebasiccontactenrichmentcredits;
      callback(available === -1 || available >= required);
    });
  }

  /**
   * Reveal Contact-details revamp
   */
  revealContactV2() {
    // Refuse a second paid reveal for the same candidate: already loading (incl. a talentpool bulk
    // reveal in progress), status still being checked, already revealed, FullEnrich still working,
    // or a reveal already fired for it this session (possibly from a slider that has since closed).
    if (this.isRevealContactLoading || this.isPreviewPending || this.candidateDetails?.revealContactAttempted
      || this.isFullEnrichPending || this.candidateSelectionService.isRevealSubmitted(this.elasticid)) {
      return;
    }
    this.checkHasEnoughCredits(this.CREDITS_REQUIRED.CONTACT_PARTNER, (hasEnough) => {
      if (!hasEnough) {
        this.toastmessage('You don`t have enough credits!', 'error');
        return;
      }
      this.doRevealContactV2();
    });
  }

  private doRevealContactV2() {
    let currentRegion = this._localstorageservice.getItem('region');
    const redirectSource = this.route.snapshot.queryParams['redirectSource'];

    if(redirectSource === 'talent-insights'){
      currentRegion = this.aggService.getTalentInsightsRedirectDataV2()?.continentstobeincluded[0] || this._localstorageservice.getItem('talentRegion');
    } else if(this.route.snapshot.queryParams['searchSource'] == 'history-component'){
      currentRegion = this._localstorageservice.getItem('talentRegion');
    }

    const data = {
      elastic_id: this.elasticid,
      enrichedfrom: this.enrichedfrom,
      continent: currentRegion
    }
    this.isRevealContactLoading = true;
    const revealedElasticId = this.elasticid;
    this.candidateSelectionService.markRevealSubmitted([revealedElasticId]);
    this.revealContactEventEmitter.emit({status: 'reveal-contact-clicked', data: {candidatenumber: this.candidateDetails?.candidatenumber ? this.candidateDetails?.candidatenumber : this.candidateDetails?.id, enrichedfrom: this.enrichedfrom}});

    setTimeout(() => {
      this.isRevealContactEmailLoading = true
    }, 7000)
    this.personSearchService.revealContactV2(data).subscribe((result: any) => {
      this.fetchcredits();
      if (result && result.body.pending) {
        this.candidateSelectionService.markRevealSeenPending(revealedElasticId);
      } else {
        this.candidateSelectionService.clearRevealSubmitted(revealedElasticId);
      }
      if (result && result.body.providers) {
        this.contactProviderData = result?.body?.providers;
        this.candidateDetails['revealContactAttempted'] = 1;

        result.body.message['usedWebbtreeIntroduction'] = this.candidateDetails["usedWebbtreeIntroduction"] ? 1 : 0;
        result.body.message['iswebbtreeverified'] = this.candidateDetails["iswebbtreeverified"] ? 1 : 0;
        result.body.message['revealContactAttempted'] = this.candidateDetails['revealContactAttempted'] ? 1 : 0;
        // Once reveal is completed will enabled retry reveal
        result.body.message['isRevealRetryAvailable'] = 1;

        this.candidateDetails = result.body.message
        this.candidateNumber = result.body.message.candidatenumber;

        this.fetchcredits();
        // this.getAllContactDetailsV2('revealContactV2');

        this.segregateContactDetails(result?.body?.message?.existingContactDetails);
        this.sendMessagetoChrome();

        this.customToast = true;
        this.toastmessage('', 'custom');

        const eventdata = {
          action: 'append-data',
          data: result.body.message
        }
        this.isRevealContactLoading = false;
        this.isRevealContactEmailLoading = false;
        this.handleOutputEvent.emit(eventdata);
        /**
         * reveal contact
         */
        const revealParams = {
          "User ID": this._localstorageservice.getItem('userdata').userid,
          "Candidate ID": this.elasticid,
          "Reveal Time": moment().format(),
          "Request Type": "Contact Partner",
          "Source": "Platform",
          "Reveal Complete": "Yes",
        }
        clevertap.event.push('Explore Contact', revealParams);


      }
      else if (result && result.body.pending) {
        // TRMS-2797: SignalHire alone didn't fill every gap - backend fired a FullEnrich
        // fallback in the background and responded immediately with a pending status instead
        // of making the browser wait (FullEnrich itself resolves async via webhook, 45-210s).
        this.isFullEnrichPending = true;
        this.fullEnrichPendingMessage = result.body.message || this.fullEnrichPendingMessage;

        if (result.body.partialContactDetails) {
          this.candidateDetails['contactDetails'] = { ...(this.candidateDetails['contactDetails'] || {}), ...result.body.partialContactDetails };
          this.segregateContactDetails(this.mapPartialContactDetailsToContactList(result.body.partialContactDetails));
        }

        this.toastmessage(this.fullEnrichPendingMessage, 'success');
        this.isRevealContactLoading = false;
        this.isRevealContactEmailLoading = false;
      }
        // const ele = document.getElementById('contact-dropdown');
        // ele && ele.classList.remove('show')
      // this.isRevealContactLoading = false; Will set value false, in getAllContactDetailsV2()
    }, (error) => {
      this.fetchcredits();
      // 409 = backend reveal lock held: another reveal for this candidate is genuinely running,
      // so it still counts as in flight. Anything else means nothing was started - allow again.
      if (error.status !== 409) {
        this.candidateSelectionService.clearRevealSubmitted(revealedElasticId);
      }
      if (error.status === 400 || error.status === 500) {
        //Api failure
        this.toastmessage('Something went wrong', 'error');
      }
      else if (error.status === 403) {
        //message: "not-enough-credit"
        this.toastmessage('You don`t have enough credits!', 'error');
      }
      else if (error.status === 404) {
        //message: "no-details-found"
        this.candidateDetails['revealContactAttempted'] = 1;

        const eventdata = {
          action: 'append-data',
          data: this.candidateDetails
        }
        this.handleOutputEvent.emit(eventdata);

        this.dataTransferToEmailCampaignSlider({});
      }
      else {
        this.toastmessage('Something went wrong', 'error');
      }
      this.isRevealContactLoading = false;
      this.isRevealContactEmailLoading = false;
    })
  }

  /**
   * Format name of provider shown in custom toast
   * @param provider provider's name from backend
   */
  formattedProviderName(provider){
    if(provider === 'pdl'){
      return 'People Data Lab';
    } else if(provider === 'pipl'){
      return 'PIPL';
    } else if(provider === 'rocketreach'){
      return 'Rocketreach';
    } else if(provider === 'contactout'){
      return 'ContactOut';
    }
  }

  /**
   * Get preview of work_email, personal_email and phone number
   */
  getPreviewContactDetailV2() {
    // this.isPreviewPending = true;
    this.personSearchService.previewContactDetailsV2(this.elasticid).subscribe((res: any) => {
      if (res && res?.message) {
        // this.isPreviewPending = false;
        this.isPreviewAvailable = {
          work_email: res.message?.work_email,
          personal_email: res.message?.personal_email,
          phone: res.message?.phone
        }
      }
    }, (err) => {
      this.isPreviewPending = false;
    })
  }

  /**
   * TRMS-2797: Lightweight check (reuses the v2 preview endpoint) to detect whether a
   * FullEnrich fallback job triggered by an earlier reveal click is still running in the
   * background for this candidate. Deliberately does not touch isPreviewAvailable so the
   * (currently unused) icon-preview behaviour in getPreviewContactDetailV2() is left as-is.
   */
  checkFullEnrichPendingStatus() {
    if (!this.elasticid) return;
    const elasticId = this.elasticid;
    const alreadyRevealed = !!this.candidateDetails?.revealContactAttempted;
    // Shows the preview loader (showTemplate('contactPreviewLoading')) and keeps the Reveal button
    // hidden until this candidate's reveal state is known.
    this.isPreviewPending = true;
    this.personSearchService.previewContactDetailsV2(elasticId).subscribe({
      next: (res: any) => {
        const submittedThisSession = this.candidateSelectionService.isRevealSubmitted(elasticId);
        if (res?.pendingFullEnrich) {
          submittedThisSession && this.candidateSelectionService.markRevealSeenPending(elasticId);
          this.isFullEnrichPending = true;
          this.isPreviewPending = false;
          return;
        }
        if (submittedThisSession) {
          // A retry (already-revealed candidate) clears its own record when it responds without
          // FullEnrich, so a record left here means it's still running unless FullEnrich was seen
          // queued and has now finished.
          if (alreadyRevealed && !this.candidateSelectionService.isRevealSeenPending(elasticId)) {
            this.isFullEnrichPending = true;
            this.isPreviewPending = false;
            return;
          }
          // Not pending, but the candidate object this slider was opened with predates a reveal/retry
          // fired this session (in an earlier slider, or via bulk) - load what it actually ended with.
          return this.loadSubmittedRevealOutcome(elasticId);
        }
        this.isPreviewPending = false;
      },
      error: () => { this.isPreviewPending = false; }
    });
  }

  /**
   * A reveal for this candidate was fired this session and isn't pending on FullEnrich now.
   * enrichresults returns the user's saved contacts / Reveal Contact action for it - if there's
   * neither, it either finished with nothing found (FullEnrich was seen queued and has since
   * resolved) or hasn't produced anything yet (bulk keeps working after it responds).
   */
  private loadSubmittedRevealOutcome(elasticId: string) {
    this.candidateSelectionService.fetchRevealStatusById([{ id: elasticId }], (c: any) => c.id).subscribe({
      next: (byId) => {
        const enriched = byId[elasticId];
        const contacts = enriched?.existingContactDetails || [];
        const finished = !!enriched?.revealContactAttempted || !!contacts.length || this.candidateSelectionService.isRevealSeenPending(elasticId);
        if (finished) {
          this.candidateSelectionService.clearRevealSubmitted(elasticId);
          // Same state the synchronous success / no-details-found branches of revealContactV2() leave behind.
          this.candidateDetails['revealContactAttempted'] = 1;
          // An answer without contacts must not erase the ones this candidate already has from its own data.
          if (contacts.length) {
            this.candidateDetails['existingContactDetails'] = contacts;
            this.segregateContactDetails(contacts);
          }
          if (enriched?.candidatenumber) {
            this.candidateDetails['candidatenumber'] = enriched.candidatenumber;
            this.candidateNumber = enriched.candidatenumber;
          }
          this.handleOutputEvent.emit({ action: 'append-data', data: this.candidateDetails });
        } else {
          this.isFullEnrichPending = true;
        }
        this.isPreviewPending = false;
      },
      error: () => {
        this.isFullEnrichPending = true; // a reveal is known to be in flight - never offer another
        this.isPreviewPending = false;
      }
    });
  }

  /**
   * TRMS-2797: partialContactDetails on a pending reveal response uses the same provider-keyed
   * { work_email: [], personal_email: [], phone: [] } shape as candidateDetails.contactDetails[provider]
   * elsewhere in this component (see retryRevalContact()) - flatten it into the enrichedvia-tagged
   * list shape segregateContactDetails()/the existing templates already know how to render.
   * @param partialContactDetails Object keyed by provider name, e.g. { signalhire: { work_email: [], personal_email: [], phone: [] } }
   */
  mapPartialContactDetailsToContactList(partialContactDetails) {
    const flattened = [];
    Object.keys(partialContactDetails || {}).forEach((provider) => {
      const providerDetails = partialContactDetails[provider] || {};
      (providerDetails.work_email || []).forEach((value) => flattened.push({ contactdetail: value, enrichedvia: provider, contactdetailcategory: 'professional', type: 'email' }));
      (providerDetails.personal_email || []).forEach((value) => flattened.push({ contactdetail: value, enrichedvia: provider, contactdetailcategory: 'personal', type: 'email' }));
      (providerDetails.phone || []).forEach((value) => flattened.push({ contactdetail: value, enrichedvia: provider, type: 'contactnumber' }));
    });
    return flattened;
  }

  /**Get the latest credits available */
  fetchcredits() {
    this.transactionservice.fetchcurrentplandetails(this._localstorageservice.getItem('usernumber')).subscribe((res: any) => {
      if (res.status == 'success') {
        let userData = this._localstorageservice.getItem('userdata');
        userData['balancebasiccontactenrichmentcredits'] = res.data.balancebasiccontactenrichmentcredits;
        this.totalCreditsAvailable = res.data.balancebasiccontactenrichmentcredits;
        this._localstorageservice.setItem('userdata', userData);
        this.transactionservice.createPaymentData();

        if (res.data.teamadmindetails) {
          // Here the logged in person is a Team Member
          //TODO Use of IF
          this.isteamMember = true
        }
      }
    })
  }

  /**
   * Used to segregate personal email, professional email, and phone number from existing contactdetails object.
   */
  segregateContactDetails(existingContactDetails) {
    if (existingContactDetails) {
      this.work_email = existingContactDetails.filter(
        (x) => {
          if (x.enrichedvia !== 'added-manually') this.availableContactDetailNotManual = true;
          return x.contactdetailcategory == "professional" && x.type == 'email'
        }
      );
      this.personal_email = existingContactDetails.filter(
        (x) => {
          if (x.enrichedvia !== 'added-manually') this.availableContactDetailNotManual = true;
          return x.contactdetailcategory == "personal" && x.type == 'email'
        }
      );
      this.phones = existingContactDetails.filter(
        (x) => {
          if (x.enrichedvia !== 'added-manually') this.availableContactDetailNotManual = true;
          return x.type == 'contactnumber'
        }
      );
    }

    if (this.availableContactDetailNotManual) {
      this.candidateDetails['revealContactAttempted'] = 1;
      this.hasAnyOfRequestSuccess = true;
    }
  }

  /**
   * WebtreeVerified and Webtree blocked for some domains
   * For Now Blocking all Internal Domains except some specific email.
   */
  isCurrentUserInternal() {
    const usertype = this._localstorageservice.getItem('userdata').usertypename;
    if(usertype === GlobalService.USER_TYPE.INTERNAL) return true;
    else return false;
  }

  sendMessagetoChrome() {
    let chromeid = localStorage.getItem('extensionID');
    let isExtensioninstalled
    if (chromeid) {
      try {
        window['chrome'].runtime.sendMessage(chromeid, { action: 'refreshExtension', candidateNumber: this.candidateNumber }, function (res) {
          if (res && res.similarCandidateData) {
            isExtensioninstalled = true
          }
        });
      } catch (error) {
        if (error) {
          isExtensioninstalled = false
        }
        console.error('Here is the error message', error);
      }
      setTimeout(() => {
        this.isExtensioninstalled = isExtensioninstalled
      }, 500)
    }
  }


  getAllContactDetailsV2(calledFrom = '') {
    if (this.candidateDetails && this.candidateDetails.hasOwnProperty("candidatenumber")) {
      this.availableContactDetailNotManual = false;
      this.isFetchExistingContactPending = true

      const data = {
        usernumber: this._localstorageservice.getItem("usernumber"),
        candidatenumber: this.candidateDetails.candidatenumber,
      }
      // Fetch existing contact detail api
      this.candidateservice.getContactDetails(data).subscribe((result: any) => {
        if (result && result.status == 'success') {
          if (result?.data?.contactnumbers?.length) {
            this.phones = result.data.contactnumbers.filter(
              (x) =>{
                if (x.enrichedvia !== 'added-manually') this.availableContactDetailNotManual = true;
                return x.type == "contactnumber"
              }
            );
          }
          if (result?.data?.emails?.length) {
            this.work_email = result.data.emails.filter(
              (x) =>{
                if (x.enrichedvia !== 'added-manually') this.availableContactDetailNotManual = true;
                return x.contactdetailcategory == "professional"
              }
            );
            this.personal_email = result.data.emails.filter(
              (x) => {
                if (x.enrichedvia !== 'added-manually') this.availableContactDetailNotManual = true;
                return x.contactdetailcategory == "personal"
              }
            );
          }
          if (this.availableContactDetailNotManual) {
            this.candidateDetails['revealContactAttempted'] = 1;
            this.hasAnyOfRequestSuccess = true;
          }
          // if(calledFrom == 'revealContactV2'){
          //   this.isRevealContactLoading = false;
          // }
          this.isFetchExistingContactPending = false;
          this.dataTransferToEmailCampaignSlider(result?.data);
        }
      })

      //TODO person searh listing update
      // let eventdata = {
      //   action: 'append-data',
      //   data: this.candidateDetails
      // }
    }
  }

  /**
   * Used to know either rednder in general or inside dropdown
   * @param div inital state/ Alternative source dropdown
   * @returns
   */
  isRenderCurrentDiv(div) {
    if (div === 'alternative-source') {
      //When any one of the process is done
      return !(this.candidateDetails?.iswebbtreeverified && this.candidateDetails?.usedWebbtreeIntroduction &&
        (this.candidateDetails?.revealContactAttempted || (!this.candidateDetails?.revealContactAttempted && this.isCloseNoDataFound))) &&
        (this.candidateDetails?.iswebbtreeverified || this.candidateDetails?.usedWebbtreeIntroduction || (this.candidateDetails?.revealContactAttempted || !this.isCloseNoDataFound))
    } else if (div === 'inital-state') {
      //When none of reveal operation triggers
      return (!this.candidateDetails?.iswebbtreeverified || !this.candidateDetails?.usedWebbtreeIntroduction || !this.candidateDetails?.revealContactAttempted)
    }
  }

  /** */
  markContactValidity(contactDetailObject, isValid) {
    const payload = {
      usernumber: this._localstorageservice.getItem("usernumber"),
      candidatenumber: this.candidateDetails.candidatenumber,
      isvalid: Number(isValid),
      candidatecontactdetailid: contactDetailObject.candidatecontactdetailid
    }
    this.personSearchService.markContactValidity(payload).subscribe((res: any) => {
      if (res && res.status === 'success') {
        this.successMessage = "Marked validity for contact successfully";
        setTimeout(() => this.successMessage = '', 3000);
      }
    }, (err: any) => {
      console.log("markContactValidity() err", err);
      this.errorMessage = "Something went wrong";
      setTimeout(() => this.errorMessage = '', 3000);
    }).add(() => this.getAllContactDetailsV2());
  }

  getWhatsappLink(phonenumber: string) {
    return `https://api.whatsapp.com/send/?phone=${phonenumber.trim().replace(/[\+\-\s]/g, '')}`;
  }

  copyToClipboard(content: string) {
    let dummy = document.createElement("textarea");
    document.body.appendChild(dummy);
    dummy.value = content;
    dummy.select();
    document.execCommand("copy");
    document.body.removeChild(dummy);
    this.successMessage = "Contact detail copied succesfully"
    setTimeout(() => this.successMessage = '', 3000);
  }

  getLastSeenText(contactDetailObj: any) {
    return (contactDetailObj?.pipl_validsince && contactDetailObj?.pipl_validsince != 'undefined' && Math.abs(moment().diff(contactDetailObj?.pipl_validsince, 'year')) < 10) ? 'Last seen ' + moment(contactDetailObj.pipl_validsince, 'YYYY-MM-DD').fromNow() : '';
  }

  /**
   * Function used to Request Webtree Verified;
   */
  webtreeVerifiedRequest() {
    if (this.isVerifiedLoading) {
      return;
    }
    this.checkHasEnoughCredits(this.CREDITS_REQUIRED.WEBBTREE_VERIFIED, (hasEnough) => {
      if (!hasEnough) {
        this.toastmessage('You don`t have enough credits!', 'error');
        return;
      }
      this.doWebtreeVerifiedRequest();
    });
  }

  private doWebtreeVerifiedRequest() {
    const obj = { elasticid: this.candidateDetails.idinindex || this.candidateDetails.id }
    this.isVerifiedLoading = true;
    this.requestContract.getRequestContract(obj).subscribe((res: any) => {
      if (res.status == "success") {
        this.candidateDetails["iswebbtreeverified"] = 1;
        this.hasAnyOfRequestSuccess = true;

      const ele = document.getElementById('contact-dropdown');
      ele && ele.classList.remove('show')
        let eventdata = {
          action: 'append-data',
          data: this.candidateDetails
        }
        this.handleOutputEvent.emit(eventdata);
        this.sendMessagetoChrome();
         /**
         * reveal contact from webbtree verified
         */
          const revealParams = {
            "User ID": this._localstorageservice.getItem('userdata').userid,
            "Candidate ID": this.elasticid,
            "Reveal Time": moment().format(),
            "Request Type": "Webbtree Verified",
            "Source": "Platform",
            "Reveal Complete": "Yes",
          }
          clevertap.event.push('Explore Contact', revealParams);

      } else {
        this.toastmessage('You don`t have enough credits!', 'error')
      }
      this.isVerifiedLoading = false;
    })
  }

  /**
   * Function used for Webtree Introduction
   * Require valid text message and date time slots
   */
  webtreeIntroductionRequest() {

    this.validateWebtreeIntoductionForm();
    this.webbtreeIntroductionMessageForm.markAsTouched();

    const webtreeIntroMessage = this.webbtreeIntroductionMessageForm.value;
    const dateTimeSlots = this.dateTimeSlotsArray;
    const obj = { elasticid: (this.candidateDetails.idinindex || this.candidateDetails.id), requirement: webtreeIntroMessage, preferences: dateTimeSlots }
    if (obj.elasticid && obj.requirement && obj.preferences?.length && this.dateTimeMasterForm.status === 'VALID') {
      this.isIntroductionLoading = true;
      this.personSearchService.makeRequestContact(obj).subscribe((res: any) => {
        if (res.status == "success") {
          this.hasAnyOfRequestSuccess = true
          this.candidateDetails["usedWebbtreeIntroduction"] = 1;
          let eventdata = {
            action: 'append-data',
            data: this.candidateDetails
          }

          const ele = document.getElementById('contact-dropdown');
          ele && ele.classList.remove('show');

          this.handleOutputEvent.emit(eventdata);
          this.sendMessagetoChrome();
            /**
         * reveal contact from webbtree introduction
         */
             const revealParams = {
              "User ID": this._localstorageservice.getItem('userdata').userid,
              "Candidate ID": this.elasticid,
              "Reveal Time": moment().format(),
              "Request Type": "Webbtree Introduction",
              "Source": "Platform",
              "Reveal Complete": "Yes",
            }
            clevertap.event.push('Explore Contact', revealParams);

          this.toastmessage('We have successfully submitted your request ', 'success')
        } else {
          this.toastmessage('You don`t have enough credits!', 'error')
        }
        this.isIntroductionLoading = false;
      })
    }

  }

  /**
   * Check dateTimeMasterForm validity.
   */
  validateWebtreeIntoductionForm() {
    this.dateTimeSlotsArray = Object.keys(this.dateTimeMasterForm.value).map(x => this.dateTimeMasterForm.value[x]) || [];
    const dateTimeSet = new Set();
    this.dateTimeSlotsArray.map(slot => {
      const str = JSON.stringify(slot);
      if (dateTimeSet.has(str)) {
        this.dateTimeMasterForm.setErrors({ duplicate: true });
      } else { dateTimeSet.add(str); }
      if (!slot.date || !slot.fromTime || !slot.toTime || !slot.timezone) {
        this.dateTimeMasterForm.setErrors({ invalidValues: true });
      }
      const minDiff = this.differenceInMinutes(slot.fromTime, slot.toTime);
      if (minDiff < 0) {
        this.dateTimeMasterForm.setErrors({ timeDiff: true });
      }
    });
  }
  /**
 * Calculates difference in minutes between two times
 * @param time1
 * @param time2
 * @returns
 */
  differenceInMinutes(time1: string, time2: string): number {
    const [hours1, minutes1] = time1.split(":");
    const [hours2, minutes2] = time2.split(":");
    const hoursDiff = Number(hours2) - Number(hours1);
    const minutesDiff = Number(minutes2) - Number(minutes1);
    const minDiff = hoursDiff * 60 + minutesDiff;
    return minDiff;
  }

  /**
   * Used to handle redirection from toast message to webtree verified
   */
  handleToastRedirection() {
    this.contactRevealRadioBtn && (this.contactRevealRadioBtn.checked = false);
    this.webtreeIntroductionRadioBtn && (this.webtreeIntroductionRadioBtn.checked = false);
    this.webtreeVerifiedRadioBtn.checked = true;

    this.webtreeVerifiedExpansionPanel.expanded = true;
    this.webtreeIntroExpansionPanel && (this.webtreeIntroExpansionPanel.expanded = false);
    this.contactRevealPanel && (this.contactRevealPanel.expanded = false);

    this.customToast = false;
  }


  /**On click add to contact button seperate component for add manual contact render */
  callAddToContactComponent() {
    this.canShowAddToContact = true;
    document.getElementById("maual-contact-form").scrollIntoView({
      behavior: 'smooth'
    });
  }

  /**On click of cancel button in add to component event emit and close add to contact component */
  closeAddToContact(event) {
    if (event.status === 'contact-added-manually') {
      this.getAllContactDetailsV2();
      this.sendMessagetoChrome();
      if (this.enrichedfrom === 'all-candidates' || this.enrichedfrom === 'talentpool') {
        // To refresh the candidate list
        this.handleOutputEvent.emit(null);
      }
    }
    else if (event.status === 'close') {

    }
    this.editManualContactInfo = {};
    this.canShowAddToContact = false;

  }

  /**
 * Allow editing based on type of email
 * @param contactType
 * @param contactInfo
 */
  editManualContact(contactType: string, contactInfo: any) {
    this.editManualContactInfo = {
      type: contactType,
      contactValue: contactInfo.contactdetail,
      isPrimary: contactInfo.isprimary ? true : false,
      candidatecontactdetailid: contactInfo.candidatecontactdetailid
    }
    this.canShowAddToContact = true;
  }

  /**
   * Function used to sent data in email campaing slider
   * @param data Contact details
   */
  dataTransferToEmailCampaignSlider(data) {
    if (this.enrichedfrom === 'email-campaign-target-listing') {
      this.campaignService.setContactSliderToListingData({ ...data, revealContactAttempted: this.candidateDetails?.revealContactAttempted });
    }
  }


  route2pricing() {
    this.modalService.dismissAll()
    this.router.navigateByUrl('/subscription/pricing')
  }

  sendmailexpiry(type) {
    let data = {
      expiredmetric: type
    }
    this.transactionservice.sendcreditexpirymail(data).subscribe()
  }

  OpenSendEmailModule(preSelectEmail: string = null) {
    if (this._localstorageservice.getItem('secredits') > 0) {
      const modalRef = this.modalService.open(CandidateEmailComponent, { size: 'lg' as 'lg', centered: true });
      modalRef.componentInstance.emailforCandidate = this.candidateDetails ? { ...this.candidateDetails, basicdetails: { firstname: this.candidateDetails.first_name, lastname: this.candidateDetails.last_name }, contactdetails: { emails: { existingDetails: this.candidateDetails.existingContactDetails.filter(c => c.type === 'email') } } } : null
      modalRef.componentInstance.preSelectEmail = preSelectEmail
      modalRef.componentInstance.candidatenumber = this.candidateDetails.candidatenumber,
        modalRef.componentInstance.passEntry.subscribe((x) => {
          if (x == 'emailsend') {
            this.toastmessage('Email Send Successfully', 'success')
          } else if (x == 'nocredits') {
            this.modalService.open(this.noCreditsCE, { windowClass: "myCustomModalClass", centered: true });
            this.sendmailexpiry('Smart Email credits')
          } else if (x == 'limitexceeded') {
            this.toastmessage('mail limit exceeded', 'error')
          } else if (x == 'error') {
            this.toastmessage('Something went Wrong', 'error')
          }
        });
    } else {
      this.modalService.open(this.noCreditsCE, { windowClass: "myCustomModalClass", centered: true });
      this.sendmailexpiry('Smart Email credits')
    }
  }

  /**
   * Used for custom handling of expand/collapse and radio button checked/unchecd
   * @param buttonName Name of template which trigger
   */
  handleExpansionClick(buttonName) {
    if (buttonName == 'contactRevealRadioBtn') {
      (this.contactRevealRadioBtn) && (this.contactRevealRadioBtn.checked = true);

      this.webtreeIntroductionRadioBtn && (this.webtreeIntroductionRadioBtn.checked = false);
      this.webtreeVerifiedRadioBtn && (this.webtreeVerifiedRadioBtn.checked = false);

      this.webtreeVerifiedExpansionPanel && (this.webtreeVerifiedExpansionPanel.expanded = false);
      this.webtreeIntroExpansionPanel && (this.webtreeIntroExpansionPanel.expanded = false);
      this.contactRevealPanel.expanded = true;

    }
    else if (buttonName == 'webtreeIntroductionRadioBtn') {
      this.webtreeIntroductionRadioBtn.checked = true;

      this.contactRevealRadioBtn && (this.contactRevealRadioBtn.checked = false);
      this.webtreeVerifiedRadioBtn && (this.webtreeVerifiedRadioBtn.checked = false);

      this.webtreeVerifiedExpansionPanel && (this.webtreeVerifiedExpansionPanel.expanded = false);
      this.webtreeIntroExpansionPanel.expanded = true;
      this.contactRevealPanel && (this.contactRevealPanel.expanded = false)
    }
    else if (buttonName == 'webtreeVerifiedRadioBtn') {
      this.webtreeVerifiedRadioBtn.checked = true;

      this.contactRevealRadioBtn && (this.contactRevealRadioBtn.checked = false);
      this.webtreeIntroductionRadioBtn && (this.webtreeIntroductionRadioBtn.checked = false);

      this.webtreeVerifiedExpansionPanel.expanded = true;
      this.webtreeIntroExpansionPanel && (this.webtreeIntroExpansionPanel.expanded = false)
      this.contactRevealPanel && (this.contactRevealPanel.expanded = false)
    }
  }

  /**
   * Function will used to redirect to the websites of data providers
   * @param provider name of providers
   */
  redirectToDataProviders(provider: string) {
    if (provider === 'pipl') {
      window.open('https://pipl.com/');
    }
    else if (provider === 'pdl') {
      window.open('https://www.peopledatalabs.com/');
    }
    else if (provider === 'rocketreach') {
      window.open('https://rocketreach.co/');
    } else if (provider === 'contactout') {
      window.open('https://contactout.com/');
    }
  }

  /**
   * @deprecated
   * Get preview old version
   */
  getPreviewApi() {
    const elasticid = this.candidateDetails.idinindex;
    this.personSearchService
      .previewContactDetails(elasticid)
      .subscribe((result: any) => {

      });
  }

  /**
   * Show ng-template on some conditions
   * @param templateName name of template
   * @returns boolean
   */
  showTemplate(templateName: string) {
    if (templateName === 'contactProvider') {
      return !this.candidateDetails?.revealContactAttempted && !this.isPreviewPending && !this.isFullEnrichPending
    }
    else if(templateName === 'retryContactProvider'){
      return !this.internalUser && this.candidateDetails?.revealContactAttempted && !this.isPreviewPending && this.candidateDetails['isRevealRetryAvailable'] && (this.work_email?.length || this.phones?.length || this.personal_email?.length);
    }
    else if (templateName === 'contactPreviewLoading') {
      return !this.candidateDetails?.revealContactAttempted && this.isPreviewPending;
    }
    else if (templateName === 'noDataFound') {
      return !this.internalUser && !this.isCloseNoDataFound && !this.isPreviewPending && this.candidateDetails?.revealContactAttempted && !(this.work_email?.length || this.phones?.length || this.personal_email?.length);
    }
    else if(templateName === 'webtreeVerified'){
      return !this.candidateDetails?.iswebbtreeverified && !this.internalUser;
    }
    else if(templateName === 'webtreeIntroduction'){
      return !this.candidateDetails?.usedWebbtreeIntroduction && !this.internalUser;
    }
    else if (templateName === 'noDataFound-internalUser') {
      if (!this.internalUser || this.isPreviewPending) return false;
      if (this.candidateDetails?.revealContactAttempted) {
        return !(this.work_email?.length || this.phones?.length || this.personal_email?.length);
      }
      // else {
      //   return !(this.isPreviewAvailable.work_email || this.isPreviewAvailable.personal_email || this.isPreviewAvailable.phone);
      // }
    }
    // const exploreContactParams = {
    //   "User ID": this._localstorageservice.getItem('userdata').userid,
    //   "Candidate ID":
    // }
  }

  /**
   * Used to remove spaces from text
   * Use case: Name of text uses as image name
   * @param text
   */
  removeSpacesFromString(text: string) {
    return text.replace(/ /g, "-");
  }

  /**
   * Used to track activity of user when clicked on candidate's contact details
   * @param data
   */
  trackClickActivity(data) {
    const payload = {
      type: data.type,
      contactdetail: data.contactdetail,
      contactdetailcategory: data.contactdetailcategory,
      candidatenumber: this.candidateNumber,
      clickedFrom: this.enrichedfrom
    }
    this.deb.next(payload);
  }

  /**
   * Redirect to all candidates listing
   */
  redirectToAllCandidates() {
    const candidatename = encodeURIComponent(this.candidateDetails.first_name + ' ' + this.candidateDetails.last_name);
    this.router.navigate(['/talent/candidate-list'], {
      queryParams: {
        candidate: candidatename
      }
    });
  }

  getContactsForShortlist() {
    this.isRevealContactLoading = true;
    this.revealContactEventEmitter.emit({status: 'reveal-contact-clicked', data: {candidatenumber: this.candidateDetails?.candidatenumber ? this.candidateDetails?.candidatenumber : this.candidateDetails?.id, enrichedfrom: this.enrichedfrom}});

    this.aiSourcingService.contactReveal(this.projectnumber, this.elasticid).subscribe((result: any) => {
      this.isRevealContactLoading = false;
      this.revealContactEventEmitter.emit({status: 'reveal-contact-revealed', data: {candidatenumber: this.candidateDetails?.candidatenumber ? this.candidateDetails?.candidatenumber : this.candidateDetails?.id, enrichedfrom: this.enrichedfrom}});

      if(result.data) {
        this.contactDetails = result.data;
        this.phones = result.data.filter((x) => x.type === 'contactnumber');
        this.work_email = result.data.filter((x) => x.contactdetailcategory === 'professional' && x.type === 'email');
        this.personal_email = result.data.filter((x) => x.contactdetailcategory === 'personal' && x.type === 'email');
      } else {
      this.revealContactEventEmitter.emit({status: 'reveal-contact-notrevealed', data: {candidatenumber: this.candidateDetails?.candidatenumber ? this.candidateDetails?.candidatenumber : this.candidateDetails?.id, enrichedfrom: this.enrichedfrom}});

      }
      console.log('Contacts for Shortlist:', result);
      // Handle the result here
    });
  }

  /**
   * Retry reveal contact afer reveal is completed
   */
  retryRevalContact() {
    if (this.isRevealContactLoading) {
      return;
    }
    this.checkHasEnoughCredits(this.CREDITS_REQUIRED.RETRY_CONTACT_REVEAL, (hasEnough) => {
      if (!hasEnough) {
        this.toastmessage('You don`t have enough credits!', 'error');
        return;
      }
      this.doRetryRevalContact();
    });
  }

  private doRetryRevalContact() {
    const paylod = {
      elasticId: this.elasticid,
      enrichedFrom: this.enrichedfrom
    }
    this.isRevealContactLoading = true;
    const retriedElasticId = this.elasticid;
    this.candidateSelectionService.markRevealSubmitted([retriedElasticId]);
    this.personSearchService.revealRetry(paylod).subscribe((res: any) => {
      if (res.body.pendingFullEnrich) {
        this.candidateSelectionService.markRevealSeenPending(retriedElasticId);
      } else {
        this.candidateSelectionService.clearRevealSubmitted(retriedElasticId);
      }
      if (res.body.data) {
        const contactProviderDetails = res.body.data.newContactDetails;
        const candidateData = res.body.data.candidateData
        this.segregateContactDetails(candidateData.existingContactDetails);
        this.candidateDetails['existingContactDetails'] = candidateData.existingContactDetails;

        const providers = [];
        this.candidateDetails['contactDetails'] = candidateData.contactDetails
        Object.keys(contactProviderDetails).forEach((provider)=>{
          const providerDetails = candidateData.contactDetails[provider];
          if(providerDetails?.personal_email.length || providerDetails.work_email?.length || providerDetails?.phone.length){
            providers.push(provider);
          }
        })
        this.contactProviderData = providers;
        if (res.body.pendingFullEnrich) {
          // FullEnrich was submitted for the SignalHire gap and hasn't resolved yet - no popup here,
          // the recruiter finds out via email once fullenrichResultProcessor.js resolves it later
          // (same async path as a fresh reveal). Keep the Reveal Contact button hidden meanwhile,
          // same as revealContactV2's own isFullEnrichPending handling.
          this.isFullEnrichPending = true;
        } else {
          this.contactProviderData.length && this.toastmessage('', 'custom');
        }
        this.candidateDetails['isRevealRetryAvailable'] = 0;
      }
      const eventdata = {
        action: 'append-data',
        data: { ...this.candidateDetails }
      }
      this.handleOutputEvent.emit(eventdata);
      this.isRevealContactLoading = false;
      this.isRevealContactEmailLoading = false;
    }, (err) => {
      // 409 = a reveal/retry for this candidate is genuinely running elsewhere - still in flight.
      if (err.status !== 409) {
        this.candidateSelectionService.clearRevealSubmitted(retriedElasticId);
      }
      this.toastmessage('Something went wrong', 'error');
    })
  }

}
